var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetAcres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 30.059 30.059",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.965,14.125c1.913,2.718,2.076,2.976,2.092,3.345c0.646,0.529,1.002,1.082,1.002,1.621 c0,2.141-5.571,4.535-13.03,4.535c-7.457,0-13.03-2.396-13.03-4.535c0-0.859,0.912-1.76,2.475-2.529 c0.373-0.715,0.843-1.61,1.429-2.721C2.456,14.931,0,16.703,0,19.091c0,4.244,7.743,6.535,15.029,6.535 c7.287,0,15.03-2.291,15.03-6.535C30.059,16.896,27.977,15.228,24.965,14.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.849,20.742c4.61,0,8.348-0.45,8.348-1.01c0-0.029-0.442-0.652-0.855-1.229c2.933-0.05,5.217-0.445,5.217-0.927 c0-0.013-5.186-7.367-6.614-9.396c-0.082-0.117-0.218-0.187-0.36-0.188c-0.144,0-0.279,0.07-0.362,0.187l-1.804,2.551 L13.24,4.668c-0.078-0.145-0.228-0.236-0.392-0.236c-0.165,0-0.315,0.091-0.393,0.236C10.802,7.788,4.5,19.685,4.5,19.731 C4.499,20.291,8.236,20.742,12.849,20.742z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetAcres);
export default __webpack_public_path__ + "static/media/asset-acres.6f8427309b328162c5ea61025e39941d.svg";
export { ForwardRef as ReactComponent };